<template>
  <div
    class="z-10 flex justify-center overflow-hidden bg-primary bg-[url('/images/newsletter.svg')] bg-cover text-white"
  >
    <div
      class="grid max-w-7xl grid-cols-1 gap-x-20 gap-y-10 p-4 py-10 md:grid-cols-2 md:p-10"
    >
      <div class="mx-auto flex flex-col space-y-4 text-sm lg:max-w-lg">
        <p class="text-2xl font-medium md:pr-32 lg:whitespace-nowrap">
          {{ $t('newsletter.title') }}
        </p>
        <p v-html="$t('newsletter.descritpion')"></p>
      </div>

      <div class="mx-auto flex w-full items-center lg:max-w-lg">
        <iframe
          src="https://alablaboratoria.user.com/embedded_forms/m2g0qt/public/"
          width="100%"
          height="100%"
          title="newsletter"
        ></iframe>
      </div>
    </div>
  </div>
</template>

<script setup></script>
